import {
  Alert,
  Button,
  Col,
  CopyableTextWithLabel,
  Row,
  Space,
  Title,
} from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { DrawerFooterContent } from "melco-shared-logic";

type CopyLicenseProps = {
  licenseFormvalues?: any;
  onCloseDrawer: any;
  createLicenseResponse: any;
  successMessage?: string;
  title: string;
};

const AlertWrapper = styled.div`
  margin-bottom: 25px;
`;

export const CopyLicense: React.FC<CopyLicenseProps> = ({
  title,
  createLicenseResponse,
  onCloseDrawer,
  successMessage,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div>
        <Space direction="vertical" size="middle">
          <Title level={4}>{title}</Title>
          <AlertWrapper>
            <Alert type="info" closable={false} message={successMessage} />
          </AlertWrapper>
        </Space>
        <Row>
          <Col xs={24} md={6}>
            <Space direction="vertical" size="middle">
              <CopyableTextWithLabel
                label={t("licensemanager.copylicense.licensekey")}
                text={createLicenseResponse?.serial_number ?? ""}
                copiedTooltip={t("licensemanager.copylicense.copiedtooltip")}
                copyTooltip={t("licensemanager.copylicense.copytooltip")}
                onCopiedMessage={t(
                  "licensemanager.copylicense.oncopiedmessage"
                )}
                key={"license-copy"}
              />
            </Space>
          </Col>
        </Row>
        <DrawerFooterContent>
          <Row justify="end">
            <Button
              style={{ minWidth: "80px" }}
              key="add-user-button"
              type="primary"
              onClick={() => {
                onCloseDrawer();
              }}
            >
              {t("licensemanager.buttons.done")}
            </Button>
          </Row>
        </DrawerFooterContent>
      </div>
    </>
  );
};
